import { render } from "./PartDetail.vue?vue&type=template&id=36cc682a"
import script from "./PartDetail.vue?vue&type=script&lang=js"
export * from "./PartDetail.vue?vue&type=script&lang=js"

import "./PartDetail.vue?vue&type=style&index=0&id=36cc682a&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__